module.exports = __webpack_public_path__ + "img/HectocommerceLogo.fd7b0f96.svg";